/**
 * @fileoverview gRPC-Web generated client stub for api
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v4.24.2
// source: log_service.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as log_service_pb from './log_service_pb';


export class LogServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorGetVehicleLocationHistoryByVehicleId = new grpcWeb.MethodDescriptor(
    '/api.LogService/GetVehicleLocationHistoryByVehicleId',
    grpcWeb.MethodType.UNARY,
    log_service_pb.GetVehicleLocationHistoryByVehicleIdRequest,
    log_service_pb.GetVehicleLocationHistoryByVehicleIdResponse,
    (request: log_service_pb.GetVehicleLocationHistoryByVehicleIdRequest) => {
      return request.serializeBinary();
    },
    log_service_pb.GetVehicleLocationHistoryByVehicleIdResponse.deserializeBinary
  );

  getVehicleLocationHistoryByVehicleId(
    request: log_service_pb.GetVehicleLocationHistoryByVehicleIdRequest,
    metadata: grpcWeb.Metadata | null): Promise<log_service_pb.GetVehicleLocationHistoryByVehicleIdResponse>;

  getVehicleLocationHistoryByVehicleId(
    request: log_service_pb.GetVehicleLocationHistoryByVehicleIdRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: log_service_pb.GetVehicleLocationHistoryByVehicleIdResponse) => void): grpcWeb.ClientReadableStream<log_service_pb.GetVehicleLocationHistoryByVehicleIdResponse>;

  getVehicleLocationHistoryByVehicleId(
    request: log_service_pb.GetVehicleLocationHistoryByVehicleIdRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: log_service_pb.GetVehicleLocationHistoryByVehicleIdResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/api.LogService/GetVehicleLocationHistoryByVehicleId',
        request,
        metadata || {},
        this.methodDescriptorGetVehicleLocationHistoryByVehicleId,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/api.LogService/GetVehicleLocationHistoryByVehicleId',
    request,
    metadata || {},
    this.methodDescriptorGetVehicleLocationHistoryByVehicleId);
  }

}

